module.exports = __webpack_public_path__ + "assets/images/rbyearend-12.jpg?v=89349bb1";